export const LIMIT_PER_PHONE_NUMBER = 1
export const SMS_COMM_BY_PHONE_NUMBER_ID_SORT_BY = 'updatedAt,desc'
export const SMS_COMMS_FOR_ACTIVE_THREAD_SORT_BY = 'updatedAt,desc'
export const UNKNOWN_TEXTS_PAGE_URL_NAME = '#unknownTexts'
